module.exports = __webpack_public_path__ + "static/Image_Middle@2x-8d5ce84001c24e15ef642cd34e7f74f0.png";